import styled from "styled-components";

export const PaymentFormContainer=styled.div`
height:300px;
display:flex;
flex-direction:colum;
align-item:center;
justify-content:center;


`

export const FormContainer= styled.form`
height:100px;
min-width:500px;
`